<template>
  <Modal class="dea-modal--no-footer" :visible="visible" @modalClose="$emit('close-modal')">
    <template slot="title">Cambia profilo</template>
    <template slot="content">
      <div class="dea-heading--light__xs">Vuoi passare al profilo di {{ localChild.firstname }}?</div>
      <div class="dea-modal-buttons dea-modal__profile-change-buttons">
        <Buttons class="dea-button--medium dea-button--outline" @click="$emit('close-modal')">Annulla</Buttons>
        <Buttons
          class="dea-button--large"
          data-test="modal__button--open-profile"
          :disabled="disableButton"
          @click="sendEvent(localChild)"
          >prosegui come {{ localChild.firstname }}</Buttons
        >
      </div>
    </template>
    <template slot="footer"></template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import Modal from "@/components/patterns/Modal";

export default {
  name: "ProfileModal",
  components: { Modal, Buttons },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    localChild: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      disableButton: false,
    };
  },
  methods: {
    sendEvent() {
      document.querySelector("body").classList.add("wait");
      this.disableButton = true;
      // eslint-disable-next-line no-unused-expressions
      this.localChild.event === "profile"
        ? this.$emit("open-child-profile", this.localChild.userId)
        : this.$emit("open-child-my-home", this.localChild.userId);
    },
  },
};
</script>

<style lang="scss">
@import "~deascuola-storybook/src/styles/system.utils";

.dea-modal__profile-change-buttons {
  .dea-button:first-of-type {
    margin-right: $space-large;
  }
}

.wait .dea-button {
  cursor: wait !important; //sass-lint:disable-line no-important
}
</style>
